export enum OrderStatus {
    PENDING_PAYMENT = 0,         // 待支付
    PAID_PENDING_SERVICE = 1,    // 待开启服务
    SERVICE_IN_PROGRESS = 2,     // 服务进行中
    PENDING_ACCEPTANCE = 3,      // 待验收
    COMPLETED = 4,               // 已完成
    CANCELLED = 5                // 已取消
}

// 佣金分配项
export interface CommissionAllocationItem {
    sellerId: string;           // 卖家ID
    sellerPhone: string;        // 卖家手机号
    sellerNickname: string;     // 卖家昵称
    commissionAmount: number;    // 佣金金额
    responsibility: string;      // 负责内容
}

// 佣金分配方案
export interface CommissionAllocation {
    items: CommissionAllocationItem[];
}

// 订单模型
export interface Order {
    orderId: string;            // 订单ID
    productId: string;          // 商品ID
    productName: string;        // 商品名称
    productVersion: number;     // 规格版本（0-体验版 1-标准版）
    sellerNickname: string;     // 卖家昵称
    sellerId: string;           // 卖家ID
    buyerId: string;           // 买家ID
    buyerNickname: string;     // 买家昵称
    orderAmount: number;        // 订单金额
    status: OrderStatus;        // 订单状态
    orderTime: string;         // 下单时间
    paymentTime?: string;       // 支付时间
    serviceStartTime?: string;  // 开启时间
    completionTime?: string;    // 完成时间
    commissionAllocation: CommissionAllocation;  // 佣金分配方案
    feeRate: number;            // 订单费率
    selfOperated: boolean;      // 是否自营
}

// 订单搜索参数
export interface OrderSearchParams {
    buyerPhone?: string;      // 买家手机号
    sellerPhone?: string;     // 卖家手机号
    buyerId?: string;         // 买家ID
    sellerId?: string;        // 卖家ID
    productId?: string;       // 商品ID
    productName?: string;     // 商品名称
    orderTimeStart?: string;  // 下单时间开始
    orderTimeEnd?: string;    // 下单时间结束
    paymentTimeStart?: string; // 支付时间开始
    paymentTimeEnd?: string;   // 支付时间结束
    status?: OrderStatus;      // 订单状态
    pageNum?: number;
    pageSize?: number;
}

// 退款请求参数
export interface RefundRequest {
    orderId: string;          // 订单ID
    reason: string;           // 退款原因
    amount?: number;          // 退款金额（部分退款时使用）
} 